import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const Contact = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const handleEmailClick = () => {
    window.location.href = 'mailto:support@tmper.app';
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('support@tmper.app');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy email:', error);
    }
  };

  return (
    <div className="legal-page">
      <Helmet>
        <title>Contact | Tmper</title>
        <meta name="description" content="Contact Tmper support." />
        <link rel="canonical" href="https://tmper.app/contact" />
        <meta property="og:title" content="Contact | Tmper" />
        <meta property="og:description" content="Contact Tmper support." />
        <meta property="og:url" content="https://tmper.app/contact" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-container">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Home
        </button>

        <h1>Contact Us</h1>

        <div className="contact-content">
          <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '30px' }}>
            Have questions, feedback, or need support? We'd love to hear from you!
          </p>

          <section className="contact-info">
            <h2>Email Support</h2>
            <p>
              For any inquiries, please reach out to us at:
            </p>
            <div className="email-section">
              <a href="mailto:support@tmper.app" className="email-link">
                support@tmper.app
              </a>
            </div>
            <div className="email-actions">
              <button
                className="email-button"
                onClick={handleEmailClick}
              >
                ✉️ Send Email
              </button>
              <button
                className="copy-email-button"
                onClick={handleCopyEmail}
                title="Copy email address"
              >
                {copied ? '✓ Copied!' : 'Copy Email'}
              </button>
            </div>
          </section>

          <section className="response-info">
            <h2>Response Time</h2>
            <p>
              We typically respond within 24 hours.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Contact;
